import React from "react";
import {AdminNavigation, WebNavigation} from "@navigation";
import {useRecoilValue} from "recoil";
import {states} from "@recoils";
import {Route, Routes} from "react-router-dom";

export default function RootNavigation() {
  const loading = useRecoilValue(states.loadingState);

  return (
    <Routes>
      <Route path="/admin/*" element={<AdminNavigation />} />
      <Route path="/*" element={<WebNavigation />} />
    </Routes>
  );
}
